module.exports = __webpack_public_path__ + "img/ppt.e03c800a.png";